import { Injectable } from "@angular/core";
import { HhsgSharedStuderSupportContact } from "../../models/sgportal-data-api-models/support-contact.model";
import { HhsgSharedConfigService } from "../config.service";
import { HhsgSharedHttpService } from "../http.service";

@Injectable()
export class HhsgSharedStuderSupportContactService {
    private readonly _apiServer: string;
    private readonly _controllerName = "SupportContact";

    constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) { 
        this._apiServer = _configService.appSettings.sgPortalApiServer;
    }

    public async deleteSgPortalContacts(organizationId: number) {
		this._httpService.doPostRequestAsync(
            this._apiServer, 
            this._controllerName, 
            `DeleteSupportContacts/${organizationId}`, 
            null);
	}

    public async saveContactsToSgPortal(supportContactModels: HhsgSharedStuderSupportContact[]) {
		this._httpService.doPostRequestAsync(
            this._apiServer, 
            this._controllerName, 
            "UpsertMultiple", 
            supportContactModels);
	}
}